import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQSection = () => {
  const { t } = useLanguage();

  const faqItems = t('faqList') || [];

  return (
    <section id="faq" className="py-24 bg-[#faf7ee]/40">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-5xl md:text-6xl mb-16 text-center">{t('faqTitle')}</h2>

          <Accordion type="single" collapsible className="space-y-4">
            {faqItems.map((item, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="border-2 border-neutral-200 rounded-xl px-6 hover:border-neutral-300 transition-colors"
                data-testid={`faq-item-${index}`}
              >
                <AccordionTrigger className="text-left text-lg font-medium hover:no-underline py-6">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-neutral-600 leading-relaxed pb-6">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
